// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9fa620c5","998":"fd5e2573"}[chunkId] + ".chunk.js";
};